import { useLocalStorage } from "@rehooks/local-storage";
import { useEffect } from "react";

import Box from "ds/components/Box";
import Toggle from "ds/components/Toggle";
import Typography from "ds/components/Typography";

import {
  OVERLAY_CANVAS,
  OVERLAY_ID,
  PERFORMANCE_ENABLED_KEY,
  SCRIPT_ID,
  REACT_SCAN_VERSION,
} from "./constants";
import useStrictModeWithExpiry from "./strictMode/useStrictModeWithExpiry";

const Performance = () => {
  const [isPerformanceMonitorEnabled, setPerformanceMonitor] = useLocalStorage(
    PERFORMANCE_ENABLED_KEY,
    false
  );

  const { isEnabled: isStrictModeEnabled, setEnabled: setStrictModeEnabled } =
    useStrictModeWithExpiry();

  useEffect(() => {
    if (isPerformanceMonitorEnabled) {
      const oldScript = document.getElementById(SCRIPT_ID);
      if (oldScript) {
        return;
      }
      const head = document.querySelector("head");
      const script = document.createElement("script");
      script.src = `https://unpkg.com/react-scan@${REACT_SCAN_VERSION}/dist/auto.global.js`;
      script.id = SCRIPT_ID;
      head?.prepend(script);
    } else {
      const script = document.getElementById(SCRIPT_ID);
      script?.remove();
      const overlay = document.getElementById(OVERLAY_ID);
      overlay?.remove();
      const overlayCanvas = document.querySelector(OVERLAY_CANVAS);
      overlayCanvas?.remove();
    }
  });

  return (
    <Box direction="column" gap="large" align="start">
      <Toggle
        variant="switch"
        onChange={setPerformanceMonitor}
        isSelected={isPerformanceMonitorEnabled}
        align="center"
      >
        <Typography variant="p-body3" tag="span">
          Performance Monitor
        </Typography>
      </Toggle>

      <Toggle
        variant="switch"
        onChange={setStrictModeEnabled}
        isSelected={isStrictModeEnabled}
        align="center"
      >
        <Box direction="column" align="start">
          <Typography variant="p-body3" tag="span">
            React StrictMode
          </Typography>
          <Typography variant="p-body4" tag="span" color="secondary">
            It reloads the page to toggle StrictMode.
            <br />
            Enabled StrictMode will be automatically disabled after 2 hours.
          </Typography>
        </Box>
      </Toggle>
    </Box>
  );
};

export default Performance;
